<app-productstoolbar  addLabel="Add Supplier" (addEvent)="doNewClient($event)"></app-productstoolbar>
<p-table #dt [value]="Suppliers" [columns]="SupplierCols" [lazy]="true" (onLazyLoad)="doSupplierSearch($event)" [paginator]="true" 
    [rows]="50" [totalRecords]="TotalSupplierRecords" selectionMode="single" [(selection)]="SelectedSupplier" dataKey="uuid" [responsive]="true" [rowsPerPageOptions]="[10,50,100,250,500]" [filterDelay]="1000">
    <ng-template pTemplate="header">
        <tr>
          <th style="width:40px;">&nbsp;</th>
          <th *ngFor="let col of SupplierCols" [pSortableColumn]="col.field">
            {{col.header}}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
          <th>&nbsp;</th>
        </tr>
        <tr>
			<th>&nbsp;</th>
            <th *ngFor="let col of SupplierCols">
                <input pInputText type="text" style="width: 100% !important;"  (input)="dt.filter($event.target.value, col.field, col.filterMatchMode)" [value]="dt.filters[col.field]?.value" >
            </th>
			<th>&nbsp;</th>
        </tr>        
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-i="rowIndex">
        <tr  [pSelectableRow]="rowData" (dblclick)="doEditSupplier($event, rowData)">
			<td style="width:40px;">{{i+1}}</td>
            <td *ngFor="let col of SupplierCols">
                    {{rowData[col.field]}}
            </td>
			<td><button pButton type="button" label="Edit" (click)="doEditSupplier($event, rowData)"></button>&nbsp;</td>
        </tr>
    </ng-template>
</p-table>

<p-dialog [(visible)]="showform" [modal]="true" [draggable] = "false" [style]="{width: '40vw'}">
    <p-header>
        Add Supplier
    </p-header>

          <div class="p-grid">
              <div class="p-col-6"><label class="lbl-right">Name:</label></div>
              <div class="p-col-6"><input type="text" pInputText [(ngModel)]="suppliername" class="inp-left"></div>
              <div class="p-col-6"><label class="lbl-right">Address:</label></div>
              <div class="p-col-6"><input type="text" pInputText [(ngModel)]="address1" class="inp-left"></div>
              <div class="p-col-6">&nbsp;</div>
              <div class="p-col-6"><input type="text" pInputText [(ngModel)]="address2" class="inp-left"></div>
              <div class="p-col-6">&nbsp;</div>
              <div class="p-col-6"><input type="text" pInputText [(ngModel)]="address3" class="inp-left"></div>
              <div class="p-col-6">&nbsp;</div>
              <div class="p-col-6"><input type="text" pInputText [(ngModel)]="address4" class="inp-left"></div>
              <div class="p-col-6"><label class="lbl-right">Post Code:</label></div>
              <div class="p-col-3"><input type="text" pInputText [(ngModel)]="postcode" class="inp-left"></div>
              <div class="p-col-3">&nbsp;</div>
              <div class="p-col-6"><label class="lbl-right">Phone:</label></div>
              <div class="p-col-6"><input type="text" pInputText [(ngModel)]="phone" class="inp-left"></div>
              <div class="p-col-6"><label class="lbl-right">E-mail:</label></div>
              <div class="p-col-6"><input type="text" pInputText [(ngModel)]="email" class="inp-left"></div>
              <div class="p-col-6"><label class="lbl-right">Website:</label></div>
              <div class="p-col-6"><input type="text" pInputText [(ngModel)]="website" class="inp-left"></div>
          </div>
  <p-footer>
        <button pButton type="button" label='Save' (click)="doSave()"></button>
        <button pButton type="button" label='Cancel' (click)="showform = false;"></button>
    </p-footer>
</p-dialog>